module.exports = "./img/c33048cacf2c74ff8ef00c0dfe858533.jpg";